$(document).on("click", "#drawer-toggle", function (e) {
      $('#menu-drawer').addClass('open');
      $('.custom_overlay').addClass('active');
    });
$(document).on("click", "#drawer-close", function (e) {
      $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
    });

    // Optional: Close on clicking outside
$(document).on("click", function (e) {
      if (!$(e.target).closest('#menu-drawer, #drawer-toggle').length) {
        $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
      }
    });

// Open child menu
  $(document).on('click', '.drawer-menu-item.has-children > .parent-link', function(e) {
    e.preventDefault();
    $(this).siblings('.sub-menu').addClass('open');
  });

  // Go back to parent menu
  $(document).on('click', '.sub-menu .back-btn a', function(e) {
    e.preventDefault();
    $(this).closest('.sub-menu').removeClass('open');
  });



// Toggle drawer
$(document).on("click", "#cart-toggle", function (e) {
    //location.href='/cart';
      $('#cart-drawer').addClass('open');
      $('.custom_overlay2').addClass('active');
    });

$(document).on("click", "#cart-close,.cart_empty_button", function (e) {
      $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
    });

    // Optional: Click outside to close
    $(document).on('click', function (e) {
      if (!$(e.target).closest('#cart-drawer, #cart-toggle').length) {
        $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
      }
    });




function refreshCartDrawer() {
  $.ajax({
    url: window.location.pathname,
    type: 'GET',
    dataType: 'html',
    success: function (data) {
      const $newDrawer = $(data).find('#cart_drawer_content');
      const $newCartCount = $(data).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      $('#cart_drawer_content').replaceWith($newDrawer);

      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
      } else {
        $('.cart_count_js').text('').hide();
      }
      const $items = $('.cart_item_single');
      if ($items.length === 1 && $items.find('img.item_image[alt="Shipping Protection"]').length) {
        $items.find('.cart_item_single_right_remove').trigger('click');
      }
    }
  });
}

 function updateCart(variantId, quantity, key, sellingPlan = null) {
    const payload = {
      id: key,
      quantity: quantity
    };

    if (sellingPlan) {
      payload.selling_plan = sellingPlan;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify(payload),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        refreshCartDrawer();
      },
      error: function (xhr) {
        console.error('Cart update failed:', xhr);
      }
    });
  }



 

// Plus
$(document).on('click', '.quantity_plus', function () {
  $('div#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $real = $wrap.find('input[name="quantity_single"]');
  const $fake = $wrap.find('.fake_quantity_display');

  let realQty = parseInt($real.val());
  let fakeQty = parseInt($fake.val());

  realQty++;
  fakeQty++;

  $real.val(realQty);
  $fake.val(fakeQty);

  updateCart($real.attr('variant_id'), realQty, $real.attr('key'), $real.attr('selling_plan') || null);
});

// Minus
$(document).on('click', '.quantity_minus', function () {
  $('div#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $real = $wrap.find('input[name="quantity_single"]');
  const $fake = $wrap.find('.fake_quantity_display');

  let realQty = parseInt($real.val());
  let fakeQty = parseInt($fake.val());

  if (realQty <= 0) return;

  realQty--;
  fakeQty--;

  $real.val(realQty);
  $fake.val(fakeQty);

  updateCart($real.attr('variant_id'), realQty, $real.attr('key'), $real.attr('selling_plan') || null);
});

// Remove (trigger all same-variant removes)
/*
$(document).on('click', '.cart_item_single_right_remove', function () {
  $('div#cart_drawer_content').addClass('loading_hk');

  const variantId = $(this).attr('variant_id');

  // trigger ALL remove buttons for this variant
  $(`.remove-variant-${variantId}`).each(function () {
    const itemKey = $(this).attr('key');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify({ id: itemKey, quantity: 0 }),
      contentType: 'application/json',
      dataType: 'json',
      success: function () {
        refreshCartDrawer();
      }
    });
  });
});
*/
// Remove all split lines for a variant by repeating update→check
function removeVariantEverywhere(variantId, maxTries = 5) {
  const dfd = $.Deferred();
  let tries = 0;

  function step() {
    tries++;

    // 1) Force total qty for this variant to 0
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      contentType: 'application/json; charset=UTF-8',
      dataType: 'json',
      data: JSON.stringify({ updates: { [variantId]: 0 } })
    })
    .done(function () {
      // 2) Check if any split lines with same variant still exist
      $.getJSON('/cart.js')
        .done(function (cart) {
          const stillThere = cart.items.some(it => String(it.id) === String(variantId));
          if (stillThere && tries < maxTries) {
            // keep trying until all lines are gone or we hit maxTries
            step();
          } else {
            refreshCartDrawer();
          }
        })
        .fail(dfd.reject);
    })
    .fail(dfd.reject);
  }

  step();
  return dfd.promise();
}

$(document).on('click', '.cart_item_single_right_remove', function () {
  const $btn    = $(this);
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const variantId = $btn.attr('variant_id'); // you said this is correct

  $btn.prop('disabled', true);

  removeVariantEverywhere(variantId, 6)
    .done(function (cart) {
      if (typeof refreshCartDrawer === 'function') refreshCartDrawer(cart);
    })
    .fail(function (xhr) {
      console.error('Remove loop failed:', xhr?.responseText || xhr);
    })
    .always(function () {
      $drawer.removeClass('loading_hk');
      $btn.prop('disabled', false);
    });
});











$(document).on("click", ".recommended_product_button", function(e) {
  e.preventDefault();
  var $el = $(this).addClass("loading_hk");
  $.post("/cart/add.js", {
    quantity: $el.attr("quantity"),
    id: $el.attr("variant_id"),
    selling_plan: $el.attr("selling_plan")
  }, function() {
    $.get(window.location.pathname, function(res) {
      $("#cart_drawer_content").replaceWith($(res).find("#cart_drawer_content"));
      $("#cart-drawer").removeClass("is_empty").addClass("open");
      $el.removeClass("loading_hk");
    });
  }, "json");
});


function updateVh() {
  document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
}
window.addEventListener('resize', updateVh);
window.addEventListener('load', updateVh);


$(document).on("click", "li.desktop_nav_menu.has-children > a.desktop_nav_parent", function (e) {
  e.preventDefault(); // prevent default link behavior if needed
  $(this).toggleClass('active');
  $(this).next().slideToggle(); // toggle the next sibling element (usually a submenu)
});

/*
$(document).on("click", "a.checkout_button", async function(e) {
  e.preventDefault();
$(this).addClass('loading_hk');
  const checkoutURL = await getCheckoutURL();
  window.location.href = checkoutURL;
});
*/